import React from "react";
import "../HorizontalTimeline.css";
import Plan from "./steps/Plan"; // Adjust the path as needed
import ValidateEmail from "./steps/ValidateEmail";
import CustomerDetails from "./steps/CustomerDetails";
import Confirm from "./steps/Confirm";
import { default as content } from '../content/en'

const steps = [
  { stepName: content.horizontalTimeline.step1, component: Plan.name },
  { stepName: content.horizontalTimeline.step2, component: ValidateEmail.name },
  { stepName: content.horizontalTimeline.step3, component: CustomerDetails.name },
  { stepName: content.horizontalTimeline.step4, component: "PaymentDetails" },
  { stepName: content.horizontalTimeline.step5, component: Confirm.name },
];

export default function HorizontalTimeline({ thisStep, customerSelections }) {
  return (
    <div className="stepper-wrapper">
      {steps.map((p, index) => {
        //pull out the index of the current step
        //and determine if it is completed or not
        const stepIndex = steps.findIndex(step => step.component === thisStep);
        const isLast = index === steps.length - 1;
        const completed = stepIndex > index;
        const current = stepIndex === index;

        return (
          <div key={index} className={`stepper-item ${completed ? "completed" : ""}`}>
            <div className={`step-counter ${current ? "current" : ""}`}>
              {completed ? <>&#10004;</> : index + 1}
            </div>
            <div className="step-name">{p.stepName}</div>
            <div className="step-description">
              {completed ? customerSelections[p.stepName].stepDescription : ""}
            </div>
            <div className="step-minor-details">
              <em>
                {completed ? customerSelections[p.stepName].stepDetails : ""}
              </em>
            </div>
          </div>
        );
      })}
    </div>
  );
}
